module.exports = __webpack_public_path__ + "img/shadow-btn.05153bb8.png";